import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledLosenge = styled.span<{
  $status: 'success' | 'error' | 'warning' | 'info';
  $disabled?: boolean;
}>`
  display: inline-block;
  font-weight: normal;
  text-transform: uppercase;
  border-radius: 0.25em;
  color: ${({ theme, $status, $disabled }) =>
    $disabled
      ? theme.colors.button.disabled.fg
      : theme.colors.validation[$status].text};
  background-color: ${({ theme, $status, $disabled }) =>
    $disabled
      ? theme.colors.button.disabled.bg
      : theme.colors.validation[$status].fill};
  border-color: ${({ theme, $status, $disabled }) =>
    $disabled
      ? theme.colors.button.disabled.border
      : theme.colors.validation[$status].border};
  padding: ${tvar('space.single')} ${tvar('space.double')};
  font-size: ${tvar('typographies.small.fontSize')};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;
